export default {"src":"/_next/static/media/google-button.4b60c502.svg","height":40,"width":134,"blurWidth":0,"blurHeight":0};